import React from 'react';
import { useIntl } from 'react-intl';
import Typography from '@material-ui/core/Typography';
import {
  TableFieldCellProps,
  TableFieldCells,
  TableFieldColumn,
} from '@eas/common-web';
import { formatUserName } from '@composite/defect-collection/defect-detail-dialog';
import { Redirect } from '@components/redirect/redirect';
import { Activity } from '@models';
import { EvidenceBrowserUrl } from '@enums';

function CellImagesCount<T>({ value }: TableFieldCellProps<T>) {
  const count = (value as Activity['attachments'])?.length ?? 0;
  if (count < 1) {
    return <Typography>-</Typography>;
  } else {
    return <Typography>Áno ({count})</Typography>;
  }
}

export function useColumns({
  hideRedirectInCurrent,
}: {
  hideRedirectInCurrent?: boolean;
}): TableFieldColumn<Activity>[] {
  const intl = useIntl();

  return [
    {
      name: intl.formatMessage({
        id: 'ZSD__ACTIVITIES__TABLE__COLUMN__WORK_ORDER',
        defaultMessage: 'Pracovný príkaz',
      }),
      datakey: 'workOrder.workOrderId',
      sortkey: 'workOrder.workOrderId',
      width: 200,
      CellComponent: function Cell(props) {
        return (
          <>
            <Redirect
              url={EvidenceBrowserUrl.WORK_ORDERS}
              id={props.rowValue!.workOrder?.id ?? ''}
              showRedirectInCurrent={!hideRedirectInCurrent}
            />
            {props.rowValue!.workOrder?.workOrderId}
          </>
        );
      },
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__ACTIVITIES__TABLE__COLUMN__TYPE',
        defaultMessage: 'Typ',
      }),
      datakey: 'type.name',
      sortkey: 'type.name',
      width: 300,
      CellComponent: TableFieldCells.TextCell,
    },
    // {
    //   name: intl.formatMessage({
    //     id: 'ZSD__ACTIVITIES__TABLE__COLUMN__PERFORMED',
    //     defaultMessage: 'Vykonaná',
    //   }),
    //   datakey: 'performed',
    //   sortkey: 'performed',
    //   width: 100,
    //   CellComponent: TableFieldCells.BooleanCell,
    // },
    {
      name: intl.formatMessage({
        id: 'ZSD__ACTIVITIES__TABLE__COLUMN__DESCRIPTION',
        defaultMessage: 'Popis',
      }),
      datakey: 'description',
      sortkey: 'description',
      width: 300,
      CellComponent: TableFieldCells.TextCell,
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__ACTIVITIES__TABLE__COLUMN__ACTIVITY_STATE',
        defaultMessage: 'Stav',
      }),
      datakey: 'activityState',
      sortkey: 'activityState',
      width: 120,
      CellComponent: function TextCell({ value }) {
        return <>{mapActivityStateLabel(value)}</>;
      },
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__ACTIVITIES__TABLE__COLUMN__TECHNICIAN',
        defaultMessage: 'Technik',
      }),
      datakey: 'technician',
      sortkey: 'technician',
      width: 200,
      CellComponent: function TextCell({ value }) {
        return <>{formatUserName(value)}</>;
      },
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__ACTIVITIES__TABLE__COLUMN__EXECUTION_DATE',
        defaultMessage: 'Dátum',
      }),
      datakey: 'executionDate',
      sortkey: 'executionDate',
      width: 150,
      CellComponent: TableFieldCells.DateTimeCell,
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__ACTIVITIES__TABLE__COLUMN__ATTACHMENTS',
        defaultMessage: 'Prílohy',
      }),
      datakey: 'attachments',
      sortkey: 'attachments',
      width: 150,
      CellComponent: CellImagesCount,
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__ACTIVITIES__TABLE__COLUMN__NOTE',
        defaultMessage: 'Poznámka',
      }),
      datakey: 'note',
      sortkey: 'note',
      width: 300,
      CellComponent: TableFieldCells.TextCell,
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__ACTIVITIES__TABLE__COLUMN__ATTACHMENTS',
        defaultMessage: 'Prílohy',
      }),
      datakey: 'attachments',
      sortkey: 'attachments',
      width: 150,
      CellComponent: CellImagesCount,
    },
  ];
}

enum ActivityState {
  DONE = 'DONE',
  NOT_DONE = 'NOT_DONE',
  NOT_DOABLE = 'NOT_DOABLE',
}

const mapActivityStateLabel = (activity: ActivityState) => {
  switch (activity) {
    case ActivityState.DONE:
      return 'Vykonaná';
    case ActivityState.NOT_DONE:
      return 'Nevykonaná';
    case ActivityState.NOT_DOABLE:
      return 'Nie je možné vykonať';
    default:
      return `-`;
  }
};
